import React, { useEffect, useState, useRef, useCallback } from 'react'
import emptyImage from '../../Assets/schedule/Group 10647.svg'
// import CreateFormModal from './modals/createForm';
import CreateScheduleDrawer from './CreateScheduleDrawer';
import PieChartCard from './pieChartCard';
import BarGraphCard from './BarGraph';
import OngoingClassCard from './onGoingClassCard';
import ScheduleClassCard from './scheduledClass';
import CompletedClassCard from './completedClassCard';
import CancelledClassCard from './cancelledClassCard';
import Timetable from './timetable';
import PageDataLoader from 'components/pageDataLoader';
import ScheduleCalender from './sceduleCalender'
import moment from 'moment';
import RecordingsModal from 'pages/broadcast/localComponent/recordingsModal'
import Date_picker from './datePicker'
import CustomDatePicker from 'components/CustomDatePicker'
// import { Tabs, Image, Typography, Select, Row, Col, DatePicker, Input, Table, Checkbox, Alert } from 'antd';
import { Tabs, Image, Typography, Select, Row, Col, DatePicker, Input, Table, Checkbox, Alert, Spin, Tooltip } from 'antd';

import { getRecordings, setCompletedSubName } from 'actions/broadcast';
import { fetchSchedule, fetchTimetableData, fetchScheduleFilter, fetchScheduleStats, setTabType, setStdFilterTimeTable, setRoomIds, getJoinUsers, setCurrentDate, setTeacherfilter, setClassFilter, setSubFilter, setMonthOrWeek, setPageToggle, subscriptionAlert, setJoinLoader, setCardData, drawerBooleanState } from '../../actions/schedule'
import { NodataCard } from 'pages/Test';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import { ArrowLeftOutlined, InfoCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import './styles.css'
import './scheduleAdminDesign.css'
import PageHeader from 'components/pageHeader';
// Title is the section heading /courses uses for "Recently added"
// (adminMarketPlaceCourse/index.js) — 1.25rem Roboto at normal weight. Every section
// heading on this page renders through it so the two dashboards stay in step.
import { Heading, Title } from 'components/Typography';
import { Button } from 'components/Button';
import { InputSearch } from 'components/customInputs';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { EventRegister } from 'react-native-event-listeners';
import { setQuickAccessItem } from 'actions/userManagementV2';
import AulasSubscriptionModal from 'pages/common/aulasSubsriptionModal';
import ScheduleStatsCard from './ScheduleStatsCard';
import { fetchSummaryData } from '../../actions/schedule'



import scheduledIcon from '../../Assets/schedule/scheduledIcon.svg';
import ongoingIcon from '../../Assets/schedule/ongoingIcon.svg';
import completedIcon from '../../Assets/schedule/completedIcon.svg';
import cancelledIcon from '../../Assets/schedule/cancelledIcon.svg';
// Shared with ScheduleTeacher, which shows the same Overview row - see summaryStats.js.
import { summariseOverviewResp, buildOverviewCards } from './summaryStats';
import dropdownArrow from '../../Assets/schedule/dropdownArrow.svg';
import calendarIcon from '../../Assets/schedule/calendar.svg';
import plusCircleIcon from '../../Assets/schedule/plusCircle.svg';
import magnifierIcon from '../../Assets/schedule/magnifier.svg';

const { TabPane } = Tabs
const { Text } = Typography
const { Option } = Select
const { Search } = Input



let intervalId = null;

// Module-level (not component-level) latch: this file is only re-evaluated from
// scratch on a genuine full page load (reload or fresh navigation to the app) — a
// client-side route change away from /schedule and back does NOT re-run module code,
// so this correctly stays `true` across every ScheduleAdmin remount for the rest of
// this page's lifetime, and only resets to `false` on the next real reload. See its
// use next to isHardReloadRef below for why that distinction matters.
let hasScheduleAdminMountedThisPageLoad = false;

function useInterval(callback, delay) {
  const savedCallback = useRef(callback);
  const intervalRef = useRef(null);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      intervalRef.current = id;
      return () => clearInterval(id);
    }
  }, [delay]);

  useEffect(() => {
    // clear interval on when component gets removed to avoid memory leaks
    return () => clearInterval(intervalRef.current);
  }, [])

  const reset = useCallback(() => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(tick, delay)
    }
  });

  const stop = useCallback(() => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
    }
  })

  return {
    reset,
    stop
  };
}
// The /schedule-new/filter-schedule endpoint has been observed to ignore the
// startDate/endDate range params and return today's occurrences regardless.

const ScheduleAdmin = ({
  fetchSchedule, scheduleList, summaryDataList, timetableDataList, fetchTimetableData, stdListFilter, fetchScheduleFilter, fetchScheduleStats, todayActivities,
  subListFilter, isMonthOrWeek, setTabType, setStdFilterTimeTable, stdTimetable, roomIds, setRoomIds, getJoinUsers, access, setCurrentDate, currentDate, setTeacherfilter,
  setClassFilter, setSubFilter, setMonthOrWeek, getRecordings, setCompletedSubName, classFilter, subFilter, pageToggle, setPageToggle, subscriptionAlert, subsAlertData, user,
  setJoinLoader, setCardData, setQuickAccessItem, quickAccessItem, fetchSummaryData, drawerValue, drawerBooleanState
}) => {

  const [key, SetKey] = useState("1")
  const [isModalVisible, setModalVisible] = useState(false)
  const [std, setStd] = useState([])
  const [sub, setSub] = useState([])
  const [date, setDate] = useState('')
  const [topic, setTopic] = useState('')
  const [stdTimetableFilter, setStdTimetableFilter] = useState(null)
  const [pageLoader, togglePageLoader] = useState(true)
  const [sectionLoader, setSectionLoader] = useState(false)
  let [listToShow, setListToShow] = useState([])
  let [noOfitemToShow, setNoOfItemToShow] = useState(6)
  const [visibleButton, setVisibleButton] = useState(true)
  const [isRecordingsModalVisible, setRecordingsModalVisibility] = useState(false);
  const [futureDate, setFutureDate] = useState(moment().format('YYYY/MM/DD'))
  const [teacherName, setTeacherName] = useState('')
  const [location, setLocation] = useState(0)
  const location1 = useLocation()
  // A hard/manual page refresh keeps the browser's native history-state object alive
  // (window.history.state survives reloads), so `location.state.currentDate` left over
  // from a PREVIOUS visit to this page can still be sitting there and gets treated as
  // "the date the user wants" on every following refresh, even though nothing on this
  // load actually set it — that's why the date filter/Overview picker kept snapping
  // back to an old date instead of today. Detect an actual reload via the Navigation
  // Timing API and ignore location.state's currentDate when it's one, so date filters
  // always fall back to today on a fresh/hard refresh.
  //
  // BUG THIS FIXED: performance.getEntriesByType('navigation')[0].type describes how
  // the CURRENT DOCUMENT was loaded, once — it stays 'reload' for the entire lifetime
  // of the page, it does NOT reset for client-side route changes. So after a user hard-
  // refreshed even once this session, EVERY later ScheduleAdmin remount (e.g. every
  // Play → Back round trip, which never reloads the document) read the same stale
  // 'reload' value and permanently treated itself as a fresh refresh — silently
  // dropping the resource-return relay's currentDate/scheduleId forever after. Gate it
  // on the module-level latch too: only the very first ScheduleAdmin mount since this
  // page genuinely loaded is allowed to be "a reload"; every remount after that within
  // the same page load is never treated as one, regardless of what the Performance API
  // still reports.
  const isHardReloadRef = useRef(
    !hasScheduleAdminMountedThisPageLoad &&
    typeof performance !== 'undefined' &&
    typeof performance.getEntriesByType === 'function' &&
    performance.getEntriesByType('navigation')[0]?.type === 'reload'
  );
  hasScheduleAdminMountedThisPageLoad = true;
  // Only trust it when it's clearly a "return to schedule" relay — not just any
  // location.state that happens to carry a currentDate key, so an unrelated stale
  // history entry (e.g. browser-back through several other modules) can't
  // resurrect an old date either. fromRecordingPlay:true is set by three relays
  // now: goToRecordingsPage (ScheduleDetailsDrawer.js, Play -> Back), the
  // markAttendanceHandler in the offline class cards (Mark/Edit attendance ->
  // Back), and the quiz add/edit flow, which instead sets scheduleId.
  const isTrustedScheduleReturn = !isHardReloadRef.current &&
    (location1?.state?.fromRecordingPlay || location1?.state?.scheduleId);
  const trustedNavCurrentDate = isTrustedScheduleReturn ? location1?.state?.currentDate : undefined;
  // TEMP DIAGNOSTIC — remove once the date-restore-on-back issue is confirmed fixed.
  console.log('[attendance-date-debug] ScheduleAdmin render: location1.state =', location1?.state, 'isHardReload =', isHardReloadRef.current, 'isTrustedScheduleReturn =', isTrustedScheduleReturn, 'trustedNavCurrentDate =', trustedNavCurrentDate);
  const [isSubModalVisible, setIsSubModalVisible] = useState(false);
  const [isBatchOpen, setIsBatchOpen] = useState(false);
  const [isSubjectOpen, setIsSubjectOpen] = useState(false);
  const batchSelectRef = useRef(null);
  const subjectSelectRef = useRef(null);
  const [yearOpen, setYearOpen] = useState(false);
  const [monthOpen, setMonthOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  // Year/Month/Days dropdowns are fully manually controlled (open={...} +
  // onDropdownVisibleChange) so their custom suffixIcon can drive opening -
  // but that also means antd's own click-outside auto-close can't be
  // trusted here (getPopupContainer renders the popup inside
  // .summary-controls itself, alongside the icon that manually forces the
  // open state), so click-outside is handled explicitly below instead of
  // assuming antd's default wiring already covers it.
  const summaryControlsRef = useRef(null);
  useEffect(() => {
    if (!yearOpen && !monthOpen && !viewOpen) return;
    const handleClickOutside = (e) => {
      if (summaryControlsRef.current && !summaryControlsRef.current.contains(e.target)) {
        setYearOpen(false);
        setMonthOpen(false);
        setViewOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [yearOpen, monthOpen, viewOpen]);
  const [isDateHover, setIsDateHover] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [isAnyDrawerOpen, setIsAnyDrawerOpen] = useState(false);
  // Measures the "Schedule" title bar's real rendered height and exposes it as
  // --schedule-title-h on the page root, so the sticky filter row (which stacks
  // directly beneath the sticky title) can offset its own `top` by exactly that
  // amount instead of a guessed pixel value - stays correct across breakpoints,
  // font-loading reflows, and if either bar's content/height ever changes.
  const titleBarRef = useRef(null);
  const pageRootRef = useRef(null);
  useEffect(() => {
    const titleEl = titleBarRef.current;
    const rootEl = pageRootRef.current;
    if (!titleEl || !rootEl) return;
    const applyHeight = () => {
      rootEl.style.setProperty('--schedule-title-h', `${titleEl.offsetHeight}px`);
    };
    applyHeight();
    const observer = new ResizeObserver(applyHeight);
    observer.observe(titleEl);
    return () => observer.disconnect();
  }, []);
  // When coming from classroom with a classId, the key useEffect must be skipped on
  // first render (before the mount-only useEffect runs the filtered fetch).
  // Initialise the ref to true HERE (sync, before any effects) when the condition is met.
  const skipKeyEffectRef = useRef(
    !!(location1?.state?.key === 'fromClassroom' && location1?.state?.classroom?.classId)
  );
  // Tracks whether the [key] effect below has already done its one-time "default to
  // today" load for the Schedule tab. `pageToggle` (redux) can't be used for this —
  // it's initialised to '1' in the reducer, the same value the effect's own else
  // branch sets it to, so it can never distinguish "first time landing on this tab"
  // from "coming back to it after already picking a date". That made the effect reset
  // the date filter to today every time you switched away to Timetable and back.
  const hasLoadedScheduleOnceRef = useRef(false);

  // The `apicall:scheduleHome` listener and the 30s auto-refresh below fire from
  // outside this component's normal render/effect cycle (a global event, a timer) —
  // if either read `currentDate`/`topic`/`std`/`sub` straight from their closures,
  // they can catch a render that hasn't flushed a just-changed date filter yet and
  // silently refetch the wrong date (observed as: date filter shows the newly picked
  // date, but the cards still reflect the previous/today's date). Keep this ref in
  // sync on every render so those callbacks always read the latest filter state.
  const filterStateRef = useRef({ currentDate, date, topic, std, sub });
  filterStateRef.current = { currentDate, date, topic, std, sub };





  // 🔹 Overview date range (for /schedule-new/filter-schedule with startDate+endDate)
  const [overviewRange, setOverviewRange] = useState([
    moment().startOf('month'),
    moment().endOf('month'),
  ]);

  // Counts from the overview range API call — kept separate from scheduleList
  const [overviewStats, setOverviewStats] = useState({ scheduled: 0, ongoing: 0, completed: 0, cancelled: 0 });
  const [todayStats, setTodayStats] = useState({ scheduled: 0, ongoing: 0, completed: 0, cancelled: 0 });

  console.log(location1, "location1")
  // 🔹 Summary header controls (for /schedule-new/summary-data)
  const [summaryRange, setSummaryRange] = useState(() => {
    const day = moment().date();
    if (day < 8) return [moment().date(1).startOf('day'), moment().date(7).endOf('day')];
    if (day < 15) return [moment().date(8).startOf('day'), moment().date(14).endOf('day')];
    if (day < 22) return [moment().date(15).startOf('day'), moment().date(21).endOf('day')];
    if (day < 29) return [moment().date(22).startOf('day'), moment().date(28).endOf('day')];
    return [moment().date(29).startOf('day'), moment().date(29).add(6, 'days').endOf('day')];
  });

  const [summaryView, setSummaryView] = useState('week'); // days | weeks | month
  const [summaryYear, setSummaryYear] = useState(moment().year());
  const [summaryMonth, setSummaryMonth] = useState(moment().month());

  // "Today's activities" (pie) and "Summary" (bar graph) are fed by their own
  // endpoints — a fixed ?date=today filter-schedule call and /summary-data — neither
  // of which is touched when the date-filtered card list is refetched. So creating,
  // cancelling, starting or ending a class moved the cards but left both charts
  // showing pre-action numbers until a full page reload. The refreshers below are
  // called from every place the cards are refreshed (the `apicall:scheduleHome`
  // event that all those actions emit, and the 30s bucket-drift interval).
  //
  // Keep the summary range/view in a ref for the same reason filterStateRef exists:
  // these run from callbacks that live outside the render cycle (a global event
  // listener, a timer), so reading the state through a closure could refetch a range
  // the user has already navigated away from.
  const summaryStateRef = useRef({ summaryRange, summaryView });
  summaryStateRef.current = { summaryRange, summaryView };

  const applyTodayStats = useCallback((resp) => {
    if (!resp) return;
    setTodayStats({
      scheduled: resp.scheduled?.length || 0,
      ongoing: resp.ongoing?.length || 0,
      completed: resp.completed?.length || 0,
      cancelled: resp.cancelled?.length || 0,
    });
  }, []);

  // An unfiltered today query is exactly what the pie chart wants — so when the card
  // list is already fetching that same thing, read the counts off its response instead
  // of firing a second, identical request behind it.
  const isUnfilteredToday = (dateStr, searchTopic, classIds, subjectIds) =>
    dateStr === moment().format('YYYY-MM-DD') &&
    !searchTopic &&
    (!classIds || classIds.length === 0) &&
    (!subjectIds || subjectIds.length === 0);

  const refreshTodayStats = useCallback(() => {
    const today = moment().format('YYYY-MM-DD');
    // skipListUpdate=true — this is the fixed "today" query for the pie chart only,
    // unrelated to whatever date the user actually has selected in the filter; without
    // it, this response would overwrite the selected date's cards in scheduleList.
    fetchScheduleFilter(today, '', [], [], applyTodayStats, null, true);
  }, [fetchScheduleFilter, applyTodayStats]);

  // `silent` refreshes skip the loading flag. The spinner over the graph only
  // makes sense while the user is waiting for a range/view they just asked for -
  // for the background refreshes (the apicall:scheduleHome event, which fires on
  // every create/edit/cancel/delete/publish anywhere on the page) it just flashed
  // a loader across a graph that was already on screen, which read as the graph
  // endlessly reloading itself. A silent refresh still updates the bars; it just
  // does it without the interruption, which is what "silently re-fetch" in the
  // comment above always meant.
  const summaryFetchInFlight = useRef(false);
  const refreshSummaryData = useCallback(({ silent = false } = {}) => {
    const { summaryRange: range, summaryView: view } = summaryStateRef.current;
    if (!range || range.length !== 2) return;
    // Coalesce a burst of silent refreshes (several actions in quick succession, or
    // several emitters answering one action) into the one request already running.
    if (silent && summaryFetchInFlight.current) return;
    summaryFetchInFlight.current = true;
    if (!silent) setSummaryLoading(true);
    fetchSummaryData(
      view,
      range[0].format('YYYY-MM-DD'),
      range[1].format('YYYY-MM-DD'),
      () => {
        summaryFetchInFlight.current = false;
        if (!silent) setSummaryLoading(false);
      }
    );
  }, [fetchSummaryData]);


  const handleCancel = () => {
    setIsSubModalVisible(false);
  };

  // 🔹 MutationObserver to track if any drawer or modal is open in the DOM
  // This is used to disable background interactions when ScheduleDetailsDrawer is open,
  // as it uses a custom mask that doesn't block interactions by default.
  useEffect(() => {
    // An element only counts as "open" if it's actually visible. Some modals
    // (e.g. RecordingsModal) stay mounted in the DOM after being closed —
    // antd only hides their `.ant-modal-wrap` via display:none instead of
    // removing `.ant-modal-root` — so checking mere presence of the root
    // would permanently disable the filters after the modal is used once.
    const isVisible = (el) => {
      if (!el) return false;
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    };

    const checkDrawerPresence = () => {
      // Check for ScheduleDetailsDrawer's custom mask or standard Ant Design drawer open class
      const hasCustomDrawer = Array.from(document.querySelectorAll('.sd-custom-mask')).some(isVisible);
      const hasStandardDrawer = Array.from(document.querySelectorAll('.ant-drawer-open')).some(isVisible);
      const hasModal = Array.from(document.querySelectorAll('.ant-modal-wrap')).some(isVisible); // Optional safety check

      setIsAnyDrawerOpen(hasCustomDrawer || hasStandardDrawer || hasModal);
    };

    // Initial check
    checkDrawerPresence();

    // Watch attribute changes too (style/class), not just node add/remove.
    // Many antd Modal/Drawer instances stay mounted and close by flipping
    // `style="display:none"` or a class on the existing wrapper rather than
    // removing it from the DOM — a childList-only observer misses that,
    // leaving isAnyDrawerOpen stuck true forever after such a close.
    const observer = new MutationObserver(checkDrawerPresence);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    // Belt-and-braces: also re-verify on a short interval in case some
    // future modal/drawer implementation toggles visibility in a way that
    // doesn't touch style/class attributes either (e.g. via a stylesheet
    // rule keyed off a different ancestor's attribute).
    const interval = setInterval(checkDrawerPresence, 500);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  // Combined flag to lock background filters whenever ANY drawer or modal is active
  const isFilterDisabled = isModalVisible || isRecordingsModalVisible || isSubModalVisible || isAnyDrawerOpen || !!drawerValue;



  useEffect(() => {
    if (quickAccessItem == 'addSchedule') {
      setModalVisible(true)
    }
  }, []);


  let roomId = []
  const handleButton = () => {
    SetKey('2');
  }
  const handleTab = (key) => {
    SetKey(key)
    setStdTimetableFilter(null)

  }


  useEffect(() => {
    // When coming from classroom with a classId, the mount useEffect (below) handles
    // the initial data fetch with the batch filter. Skip this effect on first render
    // to prevent it from resetting the batch filter or calling fetchSchedule without filter.
    if (skipKeyEffectRef.current) {
      skipKeyEffectRef.current = false;
      return;
    }
    setJoinLoader(false);
    if (key == "1") {
      setTabType('schedule')
      // TEMP DIAGNOSTIC — remove once the date-restore-on-back issue is confirmed fixed.
      console.log('[attendance-date-debug] key effect: hasLoadedScheduleOnceRef =', hasLoadedScheduleOnceRef.current, 'trustedNavCurrentDate =', trustedNavCurrentDate, 'currentDate(redux) =', currentDate, '=> branch:', (!hasLoadedScheduleOnceRef.current && !trustedNavCurrentDate) ? 'RESET-TO-TODAY' : 'FETCH-WITH-FILTER');
      if (!hasLoadedScheduleOnceRef.current && !trustedNavCurrentDate) {
        hasLoadedScheduleOnceRef.current = true;
        togglePageLoader(true)
        fetchSchedule(() => togglePageLoader(false), date)
        setCurrentDate(moment().format('DD MMM YYYY'))
        setTeacherName('')
        setMonthOrWeek('week')
        setDate(moment().format('DD MMM YYYY'))
        setClassFilter([])
        setSubFilter([])
      }
      else {
        hasLoadedScheduleOnceRef.current = true;
        setPageToggle('1')
        togglePageLoader(true)
        const parsedCurrentDate = moment(currentDate, ['DD MMM YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD');
        const parsedEndDate = date ? moment(date, ['DD MMM YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : undefined;
        fetchScheduleFilter(parsedCurrentDate, topic, std, sub, () => togglePageLoader(false), parsedEndDate)
        setTeacherName(teacherName)
        setMonthOrWeek('week')
        // keep `date` in DD MMM YYYY format consistently across the app
        setDate(currentDate)
        setClassFilter([])
        setSubFilter([])
      }
    }
    else if (key == "2") {
      setTabType('timetable')
      togglePageLoader(true)
      fetchTimetableData('', () => togglePageLoader(false))
    }



  }, [key])

  useEffect(() => {
    if (scheduleList?.scheduled?.length != 0) {
      if (noOfitemToShow < scheduleList?.scheduled?.length) {
        setVisibleButton(false)
      }
      if (noOfitemToShow <= scheduleList?.scheduled?.length) {
        listToShow = scheduleList?.scheduled?.slice(0, noOfitemToShow)
      }
      else {
        listToShow = scheduleList?.scheduled?.slice(0, scheduleList?.scheduled?.length)
      }
      setListToShow(listToShow)
    }
  }, [scheduleList?.scheduled, noOfitemToShow])

  useEffect(() => {
    if (scheduleList?.ongoing?.length != 0) {
      scheduleList?.ongoing?.map((item) => {
        roomId.push(item.roomName)
      })
      setRoomIds(roomId)
    }

  }, [scheduleList?.ongoing])

  useEffect(() => {
    setVisibleButton(true)
    if (currentDate) {
      setDate(currentDate)
    }
  }, [currentDate])

  useEffect(() => {
    subscriptionAlert();
  }, []);

  const { reset, stop } = useInterval(() => {
    if (subsAlertData?.status == undefined || subsAlertData?.status === "Fetching" || subsAlertData?.status === "Invalid") {
      subscriptionAlert();
    } else {
      stop();
    }
  }, 5000);

  // Ongoing/Scheduled/Completed buckets are computed server-side from each class's
  // start/end time, so a class that just started or just ended stays in its stale
  // bucket until the next fetch. Silently re-fetch today's list every 30s (only when
  // viewing today, since past/future days never change bucket) to keep it current.
  useInterval(() => {
    const { currentDate: latestCurrentDate, topic: latestTopic, std: latestStd, sub: latestSub } = filterStateRef.current;
    const targetDateDisplay = latestCurrentDate || moment().format('DD MMM YYYY');
    if (targetDateDisplay === moment().format('DD MMM YYYY')) {
      const targetDateStr = moment(targetDateDisplay, 'DD MMM YYYY').format('YYYY-MM-DD');
      fetchScheduleFilter(targetDateStr, latestTopic, latestStd, latestSub, () => { });
    }
  }, 30000);

  useEffect(() => {
    const classId = location1?.state?.classroom?.classId;
    const fromClassroom = location1?.state?.key === 'fromClassroom';

    if (trustedNavCurrentDate) {
      setCurrentDate(trustedNavCurrentDate);
      setDate(trustedNavCurrentDate);
    }

    if (fromClassroom && classId) {
      // Coming from Courses → Batch → Schedules VIEW: show Schedule tab filtered by batch
      // (skipKeyEffectRef is already true from initialisation, so key useEffect will be skipped)
      SetKey('1');
      setTabType('schedule');
      const todayStr = moment().format('YYYY-MM-DD');
      const todayDisplay = moment().format('DD MMM YYYY');
      const classFilter = [classId];
      setStd(classFilter);
      setClassFilter(classFilter);
      setDate(todayDisplay);
      setCurrentDate(todayDisplay);
      setMonthOrWeek('week');
      togglePageLoader(true);
      fetchScheduleFilter(todayStr, '', classFilter, [], () => togglePageLoader(false));
    } else {
      // Default / refresh behaviour: clear any leftover batch filter from a previous session
      setStd([]);
      setSub([]);
      setClassFilter([]);
      setSubFilter([]);
      // Then show Timetable tab (possibly filtered by classId for timetable view)
      setTabType('timetable');
      setStdTimetableFilter(classId);
      setStdFilterTimeTable(classId);
      togglePageLoader(true);
      fetchTimetableData(classId, () => togglePageLoader(false), null);
    }
  }, [])
  const apilistener = useRef(null);
  useEffect(() => {
    apilistener.current = EventRegister.addEventListener('apicall:scheduleHome', () => {
      // Read from the ref, not the closed-over currentDate/topic/std/sub — this listener
      // is only re-subscribed by the effect below when [date, topic, std, sub, currentDate]
      // change, which is a render+effect cycle behind a change that just happened (e.g.
      // the user picked a new date, then immediately triggered some action that emits
      // this event). The ref is updated synchronously on every render, so it always has
      // whatever's actually showing in the date filter right now.
      const { currentDate: latestCurrentDate, topic: latestTopic, std: latestStd, sub: latestSub } = filterStateRef.current;
      const targetDateDisplay = latestCurrentDate || moment().format('DD MMM YYYY');
      const targetDateStr = moment(targetDateDisplay, 'DD MMM YYYY').format('YYYY-MM-DD');
      setDate(targetDateDisplay);
      setCurrentDate(targetDateDisplay);
      togglePageLoader(true)

      // When the filter is sitting on today with nothing else applied (the page's
      // default state), this very request IS the pie chart's query — take the counts
      // straight off its response rather than repeating it.
      const listCoversToday = isUnfilteredToday(targetDateStr, latestTopic, latestStd, latestSub);

      // Update schedule list (stat cards) for currently selected date
      fetchScheduleFilter(targetDateStr, latestTopic, latestStd, latestSub, (resp) => {
        togglePageLoader(false)
        if (listCoversToday) applyTodayStats(resp);
      })

      // Every create / edit / cancel / start / end action emits this event after its
      // own API call succeeds. Those actions change today's counts and the summary
      // totals just as much as they change the cards, but neither chart is derived
      // from scheduleList — refresh them from their own endpoints too, otherwise both
      // stay on pre-action numbers until the page is reloaded.
      if (!listCoversToday) refreshTodayStats();
      // Background refresh - no spinner over a graph that's already on screen.
      refreshSummaryData({ silent: true });
    })
    return () => {
      EventRegister.removeEventListener(apilistener.current)
    }
  }, [date, topic, std, sub, currentDate])
  // On mount: load today's schedule cards
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    // The app's actual scroll container is #mainBody (Layout.js's antd
    // Content, overflow: scroll) — window/document never scrolls in this
    // shell, so window.scrollTo(0, 0) here was a no-op. Worse, Layout.js's
    // own mount effect restores #mainBody's scroll to whatever
    // xCoordinate/yCoordinate was last persisted in redux whenever
    // history.action isn't "PUSH" — which includes a hard/manual browser
    // refresh landing straight on this route. Reset #mainBody itself, and
    // defer a second reset past that effect so it wins regardless of
    // ordering.
    const resetScroll = () => document.getElementById('mainBody')?.scrollTo({ top: 0, left: 0 });
    resetScroll();
    setTimeout(resetScroll, 100);

    if (!user || Object.keys(user).length === 0) return;
    const today = moment().format('YYYY-MM-DD');
    // Load today's counts for the stats widget via ?date=today. skipListUpdate=true —
    // this is a fixed "today" query for the stats widget only, unrelated to whatever
    // date the user actually has selected in the filter; without it, this response
    // (and the filter's response for the real selected date) both write into the same
    // shared scheduleList, and whichever happens to resolve last wins — silently
    // replacing the selected date's cards with today's the moment this one lost the race.
    fetchScheduleFilter(today, '', [], [], (resp) => {
      if (resp) {
        setTodayStats({
          scheduled: resp.scheduled?.length || 0,
          ongoing: resp.ongoing?.length || 0,
          completed: resp.completed?.length || 0,
          cancelled: resp.cancelled?.length || 0,
        });
      }
    }, null, true);
  }, [user]);

  // Fetch overview stats whenever the range or user changes (handles login/logout/refresh/range-change)
  useEffect(() => {
    if (!user || Object.keys(user).length === 0) return;
    if (!overviewRange || overviewRange.length !== 2) return;
    const start = overviewRange[0].format('YYYY-MM-DD');
    const end = overviewRange[1].format('YYYY-MM-DD');
    
    // Slight delay to prevent race conditions during the initial burst of API calls on login
    const timer = setTimeout(() => {
      fetchScheduleStats(start, end, (resp) => {
        if (resp) {
          setOverviewStats(summariseOverviewResp(resp));
        }
      });
    }, 500);

    return () => clearTimeout(timer);
  }, [overviewRange, user, scheduleList]);

  useEffect(() => {
    if (!summaryRange || summaryRange.length !== 2) return;

    // 🔹 Fetch bar-graph data → /schedule-new/summary-data?startDate=...&endDate=...&type=...
    setSummaryLoading(true);
    fetchSummaryData(
      summaryView,
      summaryRange[0].format('YYYY-MM-DD'),
      summaryRange[1].format('YYYY-MM-DD'),
      () => setSummaryLoading(false)
    );
  }, [summaryRange, summaryView]);




  const onSelectStdFilter = (value, obj) => {
    setStdTimetableFilter(value)
    setStdFilterTimeTable(value)
    togglePageLoader(true)
    fetchTimetableData(value, () => togglePageLoader(false), futureDate)
  }

  const onChangeDateFilter = (date, dateString) => {
    console.log("dateString", dateString);
    setDate(dateString)
    setCurrentDate(dateString)
    setSectionLoader(true)
    fetchScheduleFilter(dateString ? moment(dateString, ['DD MMM YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '', topic, std, sub, () => setSectionLoader(false))
  }

  const onSearchTeacher = (value) => {
    setTopic(value)
    setTeacherfilter(value)
    setSectionLoader(true)
    fetchScheduleFilter(date ? moment(date, ['DD MMM YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '', value, std, sub, () => setSectionLoader(false))
    setTeacherName(value)
  }
  const onChangeStdSchedule = (value) => {
    setStd(value)
    setClassFilter(value)
    setSectionLoader(true)
    fetchScheduleFilter(date ? moment(date, ['DD MMM YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '', topic, value, sub, () => setSectionLoader(false))
  }

  const onChangeSubSchedule = (value) => {
    setSub(value)
    setSubFilter(value)
    setSectionLoader(true)
    fetchScheduleFilter(date ? moment(date, ['DD MMM YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '', topic, std, value, () => setSectionLoader(false))
  }


  const formattedSummaryRange = summaryView === 'week'
    ? `${summaryRange[0].format('D MMM')} - ${summaryRange[1].format('D MMM')}`
    : `${summaryRange[0].format('DD MMM')} - ${summaryRange[1].format('DD MMM')}`;

  const moveSummaryRange = (direction) => {
    let newStart, newEnd;
    if (summaryView === 'week') {
      if (direction === 1) { // Forward
        // Start exactly after the current end
        newStart = summaryRange[1].clone().add(1, 'day').startOf('day');
        newEnd = newStart.clone().add(6, 'days').endOf('day');
      } else { // Backward
        // End exactly before the current start
        newEnd = summaryRange[0].clone().subtract(1, 'day').endOf('day');
        newStart = newEnd.clone().subtract(6, 'days').startOf('day');
      }
    } else if (summaryView === 'month') {
      newStart = summaryRange[0].clone().add(direction, 'months').startOf('month');
      newEnd = newStart.clone().endOf('month');
    } else {
      newStart = summaryRange[0].clone().add(direction, 'days');
      newEnd = summaryRange[1].clone().add(direction, 'days');
    }

    setSummaryRange([newStart, newEnd]);
    setSummaryYear(newStart.year());
    setSummaryMonth(newStart.month());
  };

  const onSummaryYearChange = (year) => {
    setSummaryYear(year);

    let start;
    let end;
    if (summaryView === 'month') {
      start = moment().year(year).startOf('year');
      end = moment().year(year).endOf('year');
    } else if (summaryView === 'week') {
      const day = (year === moment().year() && summaryMonth === moment().month()) ? moment().date() : 1;
      if (day < 8) {
        start = moment().year(year).month(summaryMonth).date(1).startOf('day');
        end = start.clone().date(7).endOf('day');
      } else if (day < 15) {
        start = moment().year(year).month(summaryMonth).date(8).startOf('day');
        end = start.clone().date(14).endOf('day');
      } else if (day < 22) {
        start = moment().year(year).month(summaryMonth).date(15).startOf('day');
        end = start.clone().date(21).endOf('day');
      } else if (day < 29) {
        start = moment().year(year).month(summaryMonth).date(22).startOf('day');
        end = start.clone().date(28).endOf('day');
      } else {
        start = moment().year(year).month(summaryMonth).date(29).startOf('day');
        end = start.clone().add(6, 'days').endOf('day');
      }
    } else {
      start = moment().year(year).month(summaryMonth).startOf('week');
      end = start.clone().endOf('week');
    }

    setSummaryRange([start, end]);
  };


  const onSummaryMonthChange = (month) => {
    setSummaryMonth(month);

    let start;
    let end;
    if (summaryView === 'month') {
      start = moment().year(summaryYear).month(month).startOf('month');
      end = start.clone().endOf('month');
    } else if (summaryView === 'week') {
      const day = (summaryYear === moment().year() && month === moment().month()) ? moment().date() : 1;
      if (day < 8) {
        start = moment().year(summaryYear).month(month).date(1).startOf('day');
        end = start.clone().date(7).endOf('day');
      } else if (day < 15) {
        start = moment().year(summaryYear).month(month).date(8).startOf('day');
        end = start.clone().date(14).endOf('day');
      } else if (day < 22) {
        start = moment().year(summaryYear).month(month).date(15).startOf('day');
        end = start.clone().date(21).endOf('day');
      } else if (day < 29) {
        start = moment().year(summaryYear).month(month).date(22).startOf('day');
        end = start.clone().date(28).endOf('day');
      } else {
        start = moment().year(summaryYear).month(month).date(29).startOf('day');
        end = start.clone().add(6, 'days').endOf('day');
      }
    } else {
      start = moment().year(summaryYear).month(month).startOf('week');
      end = start.clone().endOf('week');
    }

    setSummaryRange([start, end]);
  };




  const onOverviewRangeChange = (dates) => {
    if (!dates) {
      setOverviewRange([
        moment().startOf('month'),
        moment().endOf('month'),
      ]);
      return;
    }
    // Always snap to full-month boundaries (1st to last day)
    const snappedStart = dates[0].clone().startOf('month');
    const snappedEnd = dates[1].clone().endOf('month');
    setOverviewRange([snappedStart, snappedEnd]);
  };


  const handleViewMore = () => {
    setNoOfItemToShow(noOfitemToShow + 3)
    setVisibleButton(true)
  }

  const handleReplay = (streamId, subject, completedItem) => {
    setCardData(completedItem)
    setCompletedSubName(subject.name);
    getRecordings(streamId, () => {
      setRecordingsModalVisibility(true);
    });
  }

  const history = useHistory();

  useEffect(() => {
    if (history.location.state?.fromQuizSave) {
      // Logic for handled fromQuizSave if needed, but no alert
    }
  }, [history.location.state]);

  function numberWithCommas(x) {
    return x.toString().split('.')[0].length > 3 ? x.toString().substring(0, x.toString().split('.')[0].length - 3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + x.toString().substring(x.toString().split('.')[0].length - 3) : x.toString();
  }

  const actions = [
    (user?.privilage?.includes('Planner') || user?.privilage?.includes('Admin') || user?.privilage?.includes('SuperAdmin')) && (!currentDate || !moment(currentDate, 'DD MMM YYYY').isBefore(moment().startOf('day'))) ?
      // The icon is sized to the CUSTOMIZE button's on /courses. That one is an antd icon,
      // so it draws at the 14px its wrapper span sets and is then scaled to 0.85 by
      // CustomButton's `.anticon svg` rule — about 12px on screen. A plain <img> is not
      // matched by that rule, so it takes the finished size directly. The 3px bottom
      // padding went with it: Button already centres the icon in a flex row.
      <Button
        type="primary"
        onClick={() => setModalVisible(true)}
        icon={<img src={plusCircleIcon} alt="plus" style={{ width: 12, height: 12 }} />}>
        CREATE SCHEDULE
      </Button>
      : null
  ]


  // Overview stat cards still use overviewStats (month-range driven)

  // Overview stat cards still use overviewStats (month-range driven)
  const statsData = buildOverviewCards(overviewStats, {
    scheduled: scheduledIcon,
    ongoing: ongoingIcon,
    completed: completedIcon,
    cancelled: cancelledIcon,
  });

  const isOverviewCurrentMonth = overviewRange && overviewRange[0] && overviewRange[1] &&
    overviewRange[0].isSame(moment().startOf('month'), 'day') &&
    overviewRange[1].isSame(moment().endOf('month'), 'day');

  return (
    <div className="schedule-admin-page" style={{ width: '100%' }} ref={pageRootRef}>
      {/* Title bar - sticky at top:0, never part of the scrolling region. Its
          real rendered height is measured above (ResizeObserver) into the
          --schedule-title-h CSS var so the sticky filter row further down
          the page can stack directly beneath it with no manual pixel guess. */}
      <div className="schedule-title-bar" ref={titleBarRef}>
        <div className="schedule-page-header" style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 99, backgroundColor: '#ffffff' }}>
          <div style={{ marginTop: -10, minHeight: 50, width: '100%' }}>
            <PageHeader
              title='Schedule'
              onBackPress={(location1?.state?.classroom?.classId || location1?.state?.key === 'fromClassroom') ? () => history.goBack() : undefined}
              actions={actions}
            />
          </div>
        </div>
      </div>
      {/* CreateScheduleDrawer must be outside the conditional so it always renders */}
      <CreateScheduleDrawer
        open={isModalVisible}
        onClose={() => {
          setModalVisible(false);
          drawerBooleanState('')
          setQuickAccessItem({ addSchedule: false });
        }}
        setIsSubModalVisible={setIsSubModalVisible}
        togglePageLoader={togglePageLoader}
        pageLoader={pageLoader}
      />
      {/* {user?.privilage?.includes("SuperAdmin") ? */}
      {/* // <div className='display-flex' style={{ height: 35, width: '100%', backgroundColor: "#F6F4FE", borderRadius: 3, borderColor: "#E6E6E6", border: "2px solid #E6E6E6" }}>
                // <div className='m-r-10'>
                //     <img src={infoImg} style={{ height: 17, width: 17 }} className="m-l-10 m-t-5" />
                // </div> */}
      {/* <div className='m-t-30'> */}
      {/* {subsAlertData?.freeHours === true ?
                        subsAlertData?.userHoursUsed >= subsAlertData?.totalUserHours ?
                            <div className='text-xmd m-t-5' style={{ color: '#636363', fontWeight: 400 }}>
                                <Alert showIcon icon={<InfoCircleOutlined />} message={<div>You have used up all your free Broadcast hours. To keep using this feature, <span onClick={() => { history.push("/broadcast-packages") }} className='text-xmd bold-600 blue cursor-pointer'>BUY A PLAN.</span></div>}></Alert>
                            </div>
                            :
                            <div className='text-xmd m-t-5' style={{ color: '#636363', fontWeight: 400 }}>
                                <Alert showIcon icon={<InfoCircleOutlined />} message={<div>You have used up {(subsAlertData?.userHoursUsed?.toFixed(2))} hours of your free Broadcast. Your remaining balance is {numberWithCommas(Math.round(((subsAlertData?.totalUserHours - subsAlertData?.userHoursUsed) * 100) || 0)/100)} free hours. To keep using this feature <span onClick={() => { history.push("/broadcast-packages") }} className='text-xmd bold-600 blue cursor-pointer'>BUY A PLAN.</span></div>}></Alert>
                            </div>
                        :
                        subsAlertData?.userHoursUsed >= subsAlertData?.totalUserHours ?
                            <div className='text-xmd m-t-5' style={{ color: '#636363', fontWeight: 400 }}>
                                <Alert showIcon icon={<InfoCircleOutlined />} message={<div> You have used up all your user hours.To keep using this feature <span onClick={() => {
                                    history.push({

                                        pathname: "/broadcast-packages",
                                        state: { key: (location + 1) }
                                    })
                                }} className='text-xmd bold-600 blue cursor-pointer'>, RECHARGE.</span></div>}></Alert>
                            </div>
                            :
                            <div className='text-xmd m-t-5' style={{ color: '#636363', fontWeight: 400 }}>
                                <Alert showIcon icon={<InfoCircleOutlined />} message={<div>You have used up {(subsAlertData?.userHoursUsed?.toFixed(2))} hours of your user hours Broadcast. Your remaining balance is {numberWithCommas(Math.round(((subsAlertData?.totalUserHours - subsAlertData?.userHoursUsed) * 100) || 0)/100)} user hours. To keep using this feature, <span onClick={() => {
                                    history.push({
                                        pathname: "/broadcast-packages",
                                        state: { key: (location + 1) }
                                    })
                                }} className='text-xmd bold-600 blue cursor-pointer'>RECHARGE.</span></div>}></Alert>
                            </div>
                    } */}
      {/* </div> */}
      {/* : null} */}
      {/* 🔹 OVERVIEW HEADER */}

      <div>
        {/* <Tabs  activeKey={key} onTabClick={handleTab} defaultActiveKey={location1?.state?.classroom?.classId ? '2' : '1'} >
                    <TabPane tab="Schedule" key="1"> */}
        <div className="schedule-content">
          <div className="schedule-overview-header">
            <Title className="overview-title">Overview</Title>

            <DatePicker.RangePicker
              value={overviewRange}
              onChange={onOverviewRangeChange}
              allowClear={!isOverviewCurrentMonth}
              bordered={false}
              inputReadOnly
              format="MMM YYYY"
              separator="-"
              suffixIcon={
                <img
                  src={calendarIcon}
                  alt="calendar"
                  style={{ width: 24, height: 24 }}
                />
              }
              picker="month"
              className={`overview-range-picker ${!isOverviewCurrentMonth ? 'can-clear' : ''}`}
              // antd 4 spells this dropdownClassName - popupClassName is the antd 5
              // name and was silently ignored, so .overview-range-dropdown never
              // reached the panel.
              dropdownClassName="overview-range-dropdown"
              // The panel has to live inside the scrolling content rather than in
              // document.body. This app scrolls #mainBody (root/Layout.js puts
              // overflow: scroll on it), not the window, and a popup parented to the
              // body is aligned once against the trigger's viewport rect and never
              // hears about that inner scroll - so it stayed where it opened while the
              // page moved under it, ending up across the title bar and the stat
              // cards. Parented to the picker's own row it is positioned against that
              // row and travels with it; .schedule-overview-header carries the
              // position: relative that makes the offsets resolve there.
              getPopupContainer={(trigger) => trigger.parentElement || document.body}
            />
          </div>

          {/* gutter={16} is horizontal-only, and the wrap gap is set here as an
              explicit `rowGap` instead of being asked of antd as gutter[1]. antd
              implements a vertical gutter one of two ways depending on a runtime
              flex-gap probe (see the charts Row below for the full story), and the
              two ways measure differently on the *outside* of the Row - so anything
              that has to line up under this Row cannot depend on it. Deciding the row
              gap here takes that variable out. */}
          <Row className="schedule-stats-row" gutter={16} style={{ rowGap: 16 }}>
            {statsData.map((item, index) => (
              <Col key={index} xs={24} sm={12} md={12} lg={6} xl={6}>
                <ScheduleStatsCard {...item} />
              </Col>
            ))}
          </Row>
        </div>


        {/* {    true||todayActivities?.scheduled == 0 && todayActivities?.ongoing == 0 && todayActivities?.completed == 0 && todayActivities?.cancelled == 0 ? */}
        {/* {todayActivities?.scheduled == 0 && todayActivities?.ongoing == 0 && todayActivities?.completed == 0 && todayActivities?.cancelled == 0 &&
                         scheduleList?.ongoing?.length == 0 && scheduleList?.scheduled?.length == 0 && scheduleList?.completed?.length == 0 && scheduleList?.cancelled?.length == 0?
                            <div className="schedule-main" style={{height:"70vh"}}>
                                <div className="schedule-empty">
                                    <Image
                                        src={emptyImage}
                                        preview={false}
                                    />
                                    <Text style={{ fontWeight: 'bold', fontSize: '18px', fontFamily: 'roboto',marginTop:"10px" }}>No live classes scheduled!</Text>
                                    <Text style={{ color: "#636363", fontSize: '14px', fontFamily: 'roboto', textAlign: 'center', marginBottom: '8px' }}>There are no live classes scheduled.</Text>
                                    <Button type="primary" size='large' style={{ borderRadius: "20px", width: "120px" }} onClick={handleButton}>Timetable</Button>
                                </div>
                            </div> : */}
        <div>
          {/* gutter[0]=16 puts 8px of padding on each side of a Col, so the gap between
              the donut and the bar chart is 16px. The -6px sides are antd's negative
              gutter margin, trimmed to bleed the cards closer to the container edge —
              not a gap, leave it alone.

              Why the vertical spacing is NOT expressed as gutter[1] here, and why these
              margins are longhands rather than a `margin` shorthand — the "chart cards
              sit on top of the stat cards after logging in, but not after a hard
              refresh" bug:

              antd's Row builds a vertical gutter in one of two completely different ways
              (grid/row.js), picked by whether the browser supports flex `gap`:

                  if (supportFlexGap) rowStyle.rowGap = gutters[1];
                  else { rowStyle.marginTop = rowStyle.marginBottom = gutters[1] / -2; }

              and in the second case Col adds a matching paddingTop/paddingBottom. Those
              two disagree by gutters[1] on the outside of the Row: the negative-margin
              version pulls the Row 8px up and 8px down over its neighbours, the rowGap
              version does not. And `supportFlexGap` comes from useFlexGapSupport(),
              which is `useState(false)` plus a `useEffect` probe — so every Row renders
              once with the margin version and then re-renders with the rowGap version,
              at which point React's style diff clears the marginTop/marginBottom keys it
              no longer sees in the style object. Clearing those longhands on an element
              whose inline declaration had been collapsed into a `margin` shorthand
              (`margin: "8px -6px 0"`, which is what this Row used to carry) wipes the
              8px top gap outright — and React does not re-write `margin`, because its
              own value did not change. Between that and the Cols losing their 8px
              padding on the same re-render, the intended 16px gap up to the stat cards
              became 0 and the two card rows landed flush. That is the overlap. A hard
              reload only appeared to fix it because the probe's result is cached per page
              load, so whether that second render changes anything is a per-session race.

              So: horizontal gutter from antd, every vertical number stated here, as a
              longhand. Identical values on both renders leaves React's diff nothing to
              remove. rowGap separates the cards when they wrap (and overrides the
              rowGap: 0 antd derives from gutters[1]); marginBottom is the 8px above
              .filter-bar, which adds to that bar's own 16px padding-top. The gap up to
              the stat cards is .schedule-content's padding-bottom — padding, so it
              cannot collapse and nothing antd does can reach it. */}
          <Row
            className="schedule-charts-row"
            gutter={16}
            align="stretch"
            style={{ marginLeft: -6, marginRight: -6, marginTop: 0, marginBottom: 8, rowGap: 16 }}
          >
            {/* Pie Chart */}
            {/* <Col xs={24} sm={24} md={8} lg={7} xl={7}> */}
            <Col xs={24} sm={24} md={12} lg={6} xl={6}>

              <div className="pieChartCard">
                <Title>
                  Today's activities
                </Title>

                {/* flex:1 rather than a fixed 290px so this box runs to the bottom of
                    the 350px card, which is what lets the legend inside it (pushed down
                    with marginTop:auto - see pieChartCard.js) land on the card's real
                    bottom edge. The donut keeps its own fixed height from its config, so
                    the extra room here becomes the gap above the legend, not a bigger
                    ring. The Summary card's chart box does the same (its legend stays on
                    top, but its chart baseline reaches this same line).
                    Restore this to go back to the tighter, higher legend:
                    <div style={{ height: '290px' }}> */}
                <div style={{ flex: 1, minHeight: 0 }}>
                  <PieChartCard activitiesData={todayStats} />
                </div>
              </div>
            </Col>

            {/* Bar Graph */}
            {/* <Col xs={24} sm={24} md={16} lg={17} xl={17}> */}
            <Col xs={24} sm={24} md={12} lg={18} xl={18}>
              {/* Column flex, like .pieChartCard already is in styles.css, so the chart
                  box below can flex down to the card's bottom edge. Restore this to go
                  back: <div className="barChartCard"> */}
              <div className="barChartCard" style={{ display: 'flex', flexDirection: 'column' }}>
                {/* Summary header */}
                <div className="summary-header">
                  <div className="summary-left">
                    <Title className="summary-title">Summary</Title>
                  </div>

                  <div className="summary-controls" ref={summaryControlsRef}>
                    {/* Date range pill - lives here (same row, next to Year/Month/Days)
                        rather than beside "Summary" or centered on its own, per request. */}
                    {summaryView === 'week' && (
                      <div className="range-pill" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span className="arrow" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => moveSummaryRange(-1)}>
                          <img
                            src={dropdownArrow}
                            alt="prev"
                            style={{ width: 12, transform: 'rotate(90deg)' }}
                          />
                        </span>
                        <span className="pill-text" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>{formattedSummaryRange}</span>
                        <span className="arrow" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => moveSummaryRange(1)}>
                          <img
                            src={dropdownArrow}
                            alt="next"
                            style={{ width: 12, transform: 'rotate(-90deg)' }}
                          />
                        </span>
                      </div>
                    )}


                    {/* Year picker */}
                    <Select
                      bordered={false}
                      value={summaryYear}
                      className="summary-select"
                      open={yearOpen}
                      dropdownMatchSelectWidth={false}
                      dropdownStyle={{ minWidth: 100 }}
                      getPopupContainer={() =>
                        document.querySelector('.summary-controls')
                      }
                      onDropdownVisibleChange={(open) => setYearOpen(open)}
                      onChange={(val) => {
                        onSummaryYearChange(val);
                        setYearOpen(false); // close after select
                      }}
                      suffixIcon={
                        <img
                          src={dropdownArrow}
                          alt="dropdown"
                          className="summary-dropdown-icon"
                          onMouseDown={(e) => {
                            e.preventDefault();     // stop focus loss
                            e.stopPropagation();    // stop default select click
                            setYearOpen((prev) => !prev); // toggle: click again to close
                            setMonthOpen(false); // only one of the three open at a time
                            setViewOpen(false);
                          }}
                        />
                      }
                    >
                      {Array.from({ length: 10 }, (_, i) => {
                        const year = 2020 + i;
                        return (
                          <Option key={year} value={year}>
                            {year}
                          </Option>
                        );
                      })}
                    </Select>




                    {/* Month picker (hidden when 'Months' view is selected) */}
                    {summaryView !== 'month' && (
                      <Select
                        bordered={false}
                        value={summaryMonth}
                        className="summary-select"
                        open={monthOpen}
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: 140 }}
                        getPopupContainer={() =>
                          document.querySelector('.summary-controls')
                        }
                        onDropdownVisibleChange={(open) => setMonthOpen(open)}
                        onChange={(val) => {
                          onSummaryMonthChange(val);
                          setMonthOpen(false);
                        }}
                        suffixIcon={
                          <img
                            src={dropdownArrow}
                            className="summary-dropdown-icon"
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setMonthOpen((prev) => !prev); // toggle: click again to close
                              setYearOpen(false); // only one of the three open at a time
                              setViewOpen(false);
                            }}
                          />
                        }
                      >
                        {moment.months().map((m, i) => (
                          <Option key={i} value={i}>
                            {m}
                          </Option>
                        ))}
                      </Select>
                    )}


                    {/* Days / Weeks */}
                    <Select
                      bordered={false}
                      value={summaryView}
                      className="summary-select"
                      open={viewOpen}
                      dropdownMatchSelectWidth={false}
                      dropdownStyle={{ minWidth: 100 }}
                      getPopupContainer={() =>
                        document.querySelector('.summary-controls')
                      }
                      onDropdownVisibleChange={(open) => setViewOpen(open)}
                      onChange={(val) => {
                        let newStart, newEnd;
                        if (val === 'week') {
                          const currentYr = moment().year();
                          const currentMth = moment().month();
                          setSummaryYear(currentYr);
                          setSummaryMonth(currentMth);

                          const day = moment().date();
                          if (day < 8) {
                            newStart = moment().year(currentYr).month(currentMth).date(1).startOf('day');
                            newEnd = newStart.clone().date(7).endOf('day');
                          } else if (day < 15) {
                            newStart = moment().year(currentYr).month(currentMth).date(8).startOf('day');
                            newEnd = newStart.clone().date(14).endOf('day');
                          } else if (day < 22) {
                            newStart = moment().year(currentYr).month(currentMth).date(15).startOf('day');
                            newEnd = newStart.clone().date(21).endOf('day');
                          } else {
                            newStart = moment().year(currentYr).month(currentMth).date(22).startOf('day');
                            newEnd = newStart.clone().endOf('month');
                          }
                        } else {
                          newStart = moment().year(summaryYear).startOf('year');
                          newEnd = moment().year(summaryYear).endOf('year');
                        }

                        setSummaryRange([newStart, newEnd]);
                        setSummaryView(val);

                        // call the fetch action directly
                        setSummaryLoading(true);
                        fetchSummaryData(val, newStart.format('YYYY-MM-DD'), newEnd.format('YYYY-MM-DD'), () => setSummaryLoading(false));

                        setViewOpen(false);
                      }}
                      suffixIcon={
                        <img
                          src={dropdownArrow}
                          className="summary-dropdown-icon"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setViewOpen((prev) => !prev); // toggle: click again to close
                            setYearOpen(false); // only one of the three open at a time
                            setMonthOpen(false);
                          }}
                        />
                      }
                    >
                      <Option value="week">Days</Option>
                      <Option value="month">Months</Option>
                    </Select>


                  </div>
                </div>



                {/* flex:1 rather than a fixed 260px, so this box ends at the same place
                    the donut card's box does (both cards are 350px with the same vertical
                    padding) and the chart inside it can run its baseline down to the
                    donut card's legend line. Restore this to go back:
                    <div style={{ height: '260px', position: 'relative' }}> */}
                <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
                  {summaryLoading && !pageLoader && (!summaryDataList || summaryDataList.length === 0) ? (
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 10,
                      background: 'rgba(255,255,255,0.7)'
                    }}>
                      <Spin size="large" />
                    </div>
                  ) : null}
                  <BarGraphCard
                    barGraphData={summaryDataList}
                    year={summaryYear}
                    view={summaryView}
                  />

                </div>
              </div>
            </Col>
          </Row>

          <div
            className="filter-bar"
            style={{
              zIndex: isFilterDisabled ? 80 : 90,
              transition: 'z-index 0.3s ease'
            }}
          >
            {/* <div className="filter-item">
    <DatePicker
      showToday
      onChange={onChangeDateFilter}
      value={
        currentDate
          ? moment(currentDate, 'DD/MM/YYYY')
          : moment()
      }
      format="DD/MM/YYYY"
      className="filter-control"
    />
  </div> */}
            {/* <div className="schedule-date-pill">
  <DatePicker
    showToday
    allowClear={true}  // ✅ Enable clear functionality
    value={
      currentDate
        ? moment(currentDate, 'DD/MM/YYYY') 
        : moment()
    }
    format="DD/MM/YYYY"                   
    bordered={false}
    onChange={onChangeDateFilter}
    suffixIcon={
      <img
        src={calendarIcon}
        alt="calendar"
        className="schedule-calendar-icon"
      />
    }
    clearIcon={
      <span className="anticon anticon-close-circle">
        <svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path>
        </svg>
      </span>
    }
    popupClassName="schedule-date-dropdown"
  />
</div> */}
            <div
              className="schedule-date-pill"
              style={{
                width: '13%',
                height: 40,
                display: 'flex',
                alignItems: 'center',
                pointerEvents: isFilterDisabled ? 'none' : 'auto',
                opacity: 1
              }}
            >
              {/* CustomDatePicker (not the plain antd DatePicker used elsewhere in
                  this file) - supports typing a date directly (DD-MM-YYYY, auto-
                  dashed as you type) in addition to the calendar popup, unlike
                  the old inputReadOnly-only setup. It shows "D MMM YYYY" (e.g.
                  "12 Aug 2026") once blurred/picked, and reverts to raw DD-MM-YYYY
                  digits when refocused for editing - see components/CustomDatePicker.js. */}
              <CustomDatePicker
                showToday
                format="DD-MM-YYYY"
                value={
                  currentDate
                    ? moment(currentDate, 'DD MMM YYYY')
                    : moment()
                }
                onChange={(newDate) => onChangeDateFilter(newDate, newDate ? newDate.format('DD MMM YYYY') : '')}
                disabled={isFilterDisabled}
                tabIndex={isFilterDisabled ? -1 : 0}
                popupClassName="schedule-date-dropdown"
                getPopupContainer={(node) => node.parentNode}
                // Today is the default state for this filter (clearing it
                // just falls back to today anyway - see the value prop above)
                // so there's nothing meaningful to clear while on today.
                hideClearOnToday
                suffixIcon={
                  <img
                    src={calendarIcon}
                    alt="calendar"
                    className="schedule-calendar-icon"
                    style={{ width: 24, height: 24 }}
                  />
                }
              />
            </div>



            <div className="filter-item" style={{
              width: '22%',
              maxWidth: '22%',
              flex: '0 1 22%',
              pointerEvents: isFilterDisabled ? 'none' : 'auto',
              opacity: 1
            }}>
              <InputSearch
                disabled={isFilterDisabled}
                tabIndex={isFilterDisabled ? -1 : 0}
                placeholder="Search by instructor"
                allowClear
                onEnter={onSearchTeacher}
                icon={<img src={magnifierIcon} alt="search" style={{ marginLeft: 5, width: 20, height: 20 }} />}
                className="filter-control"
                style={{
                  background: 'transparent',
                  border: '1px solid #AEAEAE',
                  borderRadius: 8,
                  minHeight: 40,
                  padding: '4px 10px',
                  boxSizing: 'border-box',
                  overflow: 'hidden',
                  color: '#1F1F1F',
                  width: '100%'
                }}
              />
            </div>

            {/* <Select
  mode="multiple"
  showSearch
  bordered={false}
  showArrow
  allowClear
  placeholder="Search by batch"
  value={classFilter}
  open={isBatchOpen}                 
  onDropdownVisibleChange={(open) => setIsBatchOpen(open)} 
  optionFilterProp="children"
  filterOption={(input, option) => (option && option.children ? option.children.toString().toLowerCase().includes(input.toLowerCase()) : false)}
  onChange={onChangeStdSchedule}
  className="filter-control input-like-select"
  suffixIcon={
    <img
      src={dropdownArrow}
      alt="dropdown"
      className="dropdown-icon"
      onMouseDown={(e) => {
        e.preventDefault();          
        e.stopPropagation();         
        setIsBatchOpen(prev => !prev);
      }}
    />
  }
  getPopupContainer={(node) => node.parentNode}
>
  {stdListFilter?.map((item, index) => (
    <Option key={index} value={item.id}>
      {item.std}-{item.section}
    </Option>
  ))}
</Select> */}

            <Select
              ref={batchSelectRef}
              mode="multiple"
              showSearch
              bordered={false}
              showArrow
              allowClear
              disabled={isFilterDisabled}
              tabIndex={isFilterDisabled ? -1 : 0}
              placeholder="Search by batch"
              style={{
                width: '31%',
                maxWidth: '31%',
                flex: '0 1 31%',
                background: 'transparent',
                border: '1px solid #AEAEAE',
                borderRadius: 8,
                pointerEvents: isFilterDisabled ? 'none' : 'auto',
                opacity: 1
              }}
              value={classFilter}
              open={isBatchOpen}
              onDropdownVisibleChange={(open) => {
                setIsBatchOpen(open);
                if (open) requestAnimationFrame(() => batchSelectRef.current?.scrollTo(0));
              }}
              optionFilterProp="children"
              filterOption={(input, option) => {
                const normalize = (s) => s?.toString().toLowerCase().replace(/[^a-z0-9]/g, '') || '';
                return normalize(option?.children).includes(normalize(input));
              }}
              onChange={onChangeStdSchedule}
              className="filter-control input-like-select"
              suffixIcon={
                <img
                  src={dropdownArrow}
                  alt="dropdown"
                  className="dropdown-icon"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsBatchOpen((prev) => !prev);
                  }}
                />
              }
              // Anchored into the sticky .filter-bar rather than document.body, so the panel is
              // a positioned child of the row holding the field and travels with it, instead of
              // rc-align re-measuring it against the viewport on every scroll (the drift).
              // Deliberately not node.parentNode: antd hands getPopupContainer the
              // .ant-select-selector, whose parent is the .ant-select box itself - 40px tall
              // with overflow: hidden (.filter-control.ant-select), which clips the panel down
              // into the field. Same call Production-new uses.
              getPopupContainer={() => document.querySelector('.filter-bar') || document.body}
              dropdownClassName="schedule-filter-select-dropdown"
              dropdownRender={(menu) => <div className="schedule-select-dropdown-inner">{menu}</div>}
              >
                {stdListFilter?.map((item, index) => (
                  <Option key={index} value={item.id} label={`${item.std}-${item.section}`}>
                    {item.std}-{item.section}
                  </Option>
                ))}
              </Select>





            {/* <Select
  mode="multiple"
  showSearch
  bordered={false}
  showArrow
  allowClear
  placeholder="Search by subject"
  value={subFilter}
  open={isSubjectOpen}                 // ✅ controlled
  onDropdownVisibleChange={(open) => setIsSubjectOpen(open)}   // ❌ block default toggle
  optionFilterProp="children"
  filterOption={(input, option) => (option && option.children ? option.children.toString().toLowerCase().includes(input.toLowerCase()) : false)}
  onChange={onChangeSubSchedule}
  className="filter-control input-like-select"
  suffixIcon={
    <img
      src={dropdownArrow}
      alt="dropdown"
      className="dropdown-icon"
      onMouseDown={(e) => {
        e.preventDefault();            // stop focus
        e.stopPropagation();           // stop select click
        setIsSubjectOpen(prev => !prev); // ✅ toggle
      }}
    />
  }
  getPopupContainer={(node) => node.parentNode}
>
  {subListFilter?.map((item, index) => (
    <Option key={index} value={item.id}>
      {item.name}
    </Option>
  ))}
</Select> */}

            <Select
              ref={subjectSelectRef}
              mode="multiple"
              showSearch
              bordered={false}
              showArrow
              allowClear
              disabled={isFilterDisabled}
              tabIndex={isFilterDisabled ? -1 : 0}
              placeholder="Search by subject"
              value={subFilter}
              open={isSubjectOpen}
              onDropdownVisibleChange={(open) => {
                setIsSubjectOpen(open);
                if (open) requestAnimationFrame(() => subjectSelectRef.current?.scrollTo(0));
              }}
              optionFilterProp="children"
              filterOption={(input, option) => {
                const normalize = (s) => s?.toString().toLowerCase().replace(/[^a-z0-9]/g, '') || '';
                return normalize(option?.children).includes(normalize(input));
              }}
              onChange={onChangeSubSchedule}
              onClear={() => {
                  // reopen dropdown immediately after clear
                  requestAnimationFrame(() => {
                    setIsSubjectOpen(false);
                  });
                }}
                className="filter-control input-like-select"
                suffixIcon={
                  <img
                    src={dropdownArrow}
                    alt="dropdown"
                    className="dropdown-icon"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setIsSubjectOpen((prev) => !prev);
                    }}
                  />
                }
                // Anchored into the sticky .filter-bar rather than document.body, so the panel is
                // a positioned child of the row holding the field and travels with it, instead of
                // rc-align re-measuring it against the viewport on every scroll (the drift).
                // Deliberately not node.parentNode: antd hands getPopupContainer the
                // .ant-select-selector, whose parent is the .ant-select box itself - 40px tall
                // with overflow: hidden (.filter-control.ant-select), which clips the panel down
                // into the field. Same call Production-new uses.
                getPopupContainer={() => document.querySelector('.filter-bar') || document.body}
                dropdownClassName="schedule-filter-select-dropdown"
                dropdownRender={(menu) => <div className="schedule-select-dropdown-inner">{menu}</div>}
                style={{
                  width: '31%',
                  maxWidth: '31%',
                  flex: '0 1 31%',
                  background: 'transparent',
                  border: '1px solid #AEAEAE',
                borderRadius: 8,
                pointerEvents: isFilterDisabled ? 'none' : 'auto',
                opacity: 1
              }}
              >
                {subListFilter?.map((item, index) => (
                  <Option key={index} value={item.id} label={item.name}>
                    {item.name}
                  </Option>
                ))}
              </Select>

          </div>

          {sectionLoader ? (
            <div style={{ width: '100%', padding: '32px 0', display: 'flex', justifyContent: 'center' }}>
              <Spin size="large" />
            </div>
          ) : scheduleList?.ongoing?.length != 0 || scheduleList?.scheduled?.length != 0 || scheduleList?.completed?.length != 0 || scheduleList?.cancelled?.length != 0 ?
            <div  >
              {scheduleList?.ongoing?.length != 0 ?
                <div style={{ marginTop: '16px' }}>
                  <Title>Ongoing live classes</Title>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                    {scheduleList?.ongoing?.map((item, index) => (
                      <OngoingClassCard key={item?.id || item?.occurrenceId || index} onGoingItem={item} togglePageLoader={togglePageLoader} pageLoader={pageLoader} />
                    )
                    )}
                  </div>
                </div>
                : null}

              {scheduleList?.scheduled?.length != 0 ?
                <div style={{ marginTop: '16px' }}>
                  <Title>Scheduled classes</Title>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                    {listToShow?.map((item, index) => (<ScheduleClassCard key={item?.id || item?.occurrenceId || index} scheduleItem={item} index={index} togglePageLoader={togglePageLoader} pageLoader={pageLoader} drawerBooleanState={drawerBooleanState} />))}
                  </div>
                  <div style={{ marginTop: '10px', width: '100%', display: visibleButton ? 'none' : 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                    <Button style={{ borderRadius: "16px", borderColor: 'lightskyblue' }} onClick={() => handleViewMore()} >View More</Button>
                  </div>
                </div>
                : null}
              {scheduleList?.completed?.length != 0 ?
                <div style={{ marginTop: '16px' }}>
                  <Title>Completed classes</Title>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                    {scheduleList?.completed?.map((item, index) => (<CompletedClassCard key={item?.id || item?.occurrenceId || index} completedItem={item} handleReplay={handleReplay} togglePageLoader={togglePageLoader} pageLoader={pageLoader} />))}
                  </div>
                </div>
                : null}
              {scheduleList?.cancelled?.length != 0 ?
                <div style={{ marginTop: '16px' }}>
                  <Title>Cancelled classes</Title>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                    {scheduleList?.cancelled?.map((item, index) => (<CancelledClassCard key={item?.id || item?.occurrenceId || index} cancelledItem={item} />))}
                  </div>
                </div>
                : null}
            </div>
            :
            <div className="schedule-main" >
              <div className="schedule-empty" >
                <Image
                  src={emptyImage}
                  preview={false}
                />
                <Text style={{ fontWeight: 'bold', fontSize: '18px', fontFamily: 'roboto' }}>No live classes scheduled for the selected date</Text>
                {/* <Text style={{ color: "#636363", fontSize: '14px', fontFamily: 'roboto', textAlign: 'center', marginBottom: '8px' }}>There are no live classes scheduled.</Text> */}
                {((user?.privilage?.includes('Admin') || user?.privilage?.includes('Planner') || user?.privilage?.includes('SuperAdmin')) && !moment(currentDate, 'DD MMM YYYY').isBefore(moment().startOf('day'))) ?
                  <Button type='primary' className='purpleBtnWrap radius-100 purpleButtonHoverEffect boxShadow118' icon={<PlusCircleOutlined />} onClick={() => setModalVisible(true)}>CREATE</Button>
                  : null
                }
              </div>
            </div>
          }
        </div>


        {/* </TabPane> */}
        {/* <TabPane tab="Timetable" key="2" >

                        <div >
                            <div className="timetable-fiter-button">
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div style={{ width: "220px" }}>
                                        <Select
                                            allowClear={stdTimetableFilter ? true : false}
                                            style={{ width: "220px" }}
                                            onChange={onSelectStdFilter}
                                            value={stdTimetableFilter}
                                            placeholder="Select standard"
                                            getPopupContainer={(triggerNode) => {
                                                return triggerNode.parentNode;
                                            }}
                                        >
                                            {stdListFilter?.length != 0 ? stdListFilter.map((item, index) => (
                                                <Option value={item.id}>{item.std + '-' + item.section}</Option>
                                            ))
                                                : null}
                                        </Select>
                                    </div>
                                    <div style={{ width: "200px", marginLeft: "20px" }}>
                                        <Date_picker id={stdTimetableFilter} setDate={setFutureDate} value={futureDate} />
                                    </div>
                                </div>
                                {access == true ?
                                    <div>
                                        <Button className='purpleBtnWrap radius-100 purpleButtonHoverEffect boxShadow118' onClick={() => setModalVisible(true)}><PlusCircleOutlined/> Create</Button>
                                    </div>
                                    : null}
                                {(isModalVisible && <CreateFormModal isModalVisible={isModalVisible} setIsSubModalVisible={setIsSubModalVisible} setModalVisible={setModalVisible} setFutureDate={setFutureDate} futureDate={futureDate} setQuickAccessItem={setQuickAccessItem} />)}
                            </div>
                            {stdTimetableFilter == null ?
                                <div style={{ marginTop: '14px' }}>
                                    <div className="schedule-main">
                                        <div className="schedule-empty">
                                            <Image
                                                src={emptyImage}
                                                preview={false}
                                            />
                                            <Text style={{ fontWeight: 'bold', fontSize: '18px', fontFamily: 'roboto' }}>No classes selected yet!</Text>
                                            <Text style={{ color: "#636363", fontSize: '14px', fontFamily: 'roboto', textAlign: 'center', marginBottom: '8px' }}>Please select the class to check the timetable.</Text>
                                        </div>
                                    </div>
                                </div> :

                                <div>
                                    <Timetable timetableDataSource={timetableDataList} togglePageLoader={togglePageLoader} />
                                </div>
                            }
                        </div>
                    </TabPane> */}
        {/* </Tabs> */}
      </div>

      {/* Suppressed while a drawer or modal is up: those carry their own loaders, and
          showing this one behind them put two spinners on screen at once (e.g. coming
          back from the add-quiz page, where the drawer reopens on Quizzes and fetches).
          drawerValue is checked as well as isAnyDrawerOpen because it is set before the
          navigation, whereas isAnyDrawerOpen only flips once the MutationObserver sees
          the drawer in the DOM - a gap the global loader would otherwise flash in. */}
      <PageDataLoader visible={pageLoader && !isAnyDrawerOpen && !drawerValue} />
      <RecordingsModal isRecordingsModalVisible={isRecordingsModalVisible}
        setRecordingsModalVisibility={setRecordingsModalVisibility} />
      {isSubModalVisible && <AulasSubscriptionModal
        isModalVisible={isSubModalVisible}
        handleCancel={handleCancel}
        fromSchedule={true}
      />}
    </div>
  )
}


const mapStateToProps = (state) => {
  const {
    scheduleList,
    summaryDataList,
    timetableDataList,
    stdListFilter,
    todayActivities,
    subListFilter,
    isMonthOrWeek,
    stdTimetable,
    roomIds,
    access,
    currentDate,
    classFilter,
    subFilter,
    pageToggle,
    subsAlertData,
    drawerValue
  } = state.schedule;
  const { user } = state.session;
  const { quickAccessItem } = state.userManagementV2

  return {
    scheduleList,
    summaryDataList,
    timetableDataList,
    stdListFilter,
    todayActivities,
    subListFilter,
    isMonthOrWeek,
    stdTimetable,
    roomIds,
    access,
    currentDate,
    classFilter,
    subFilter,
    pageToggle,
    subsAlertData,
    user,
    quickAccessItem,
    drawerValue
  };
};


const mapDispatchToProps = (dispatch) => ({
  fetchSchedule: (callback, date) => dispatch(fetchSchedule(callback, date)),
  fetchTimetableData: (value, callback, date) => dispatch(fetchTimetableData(value, callback, date)),
  fetchScheduleFilter: (date, topic, std, sub, callback, endDate, skipListUpdate) => dispatch(fetchScheduleFilter(date, topic, std, sub, callback, endDate, skipListUpdate)),
  setTabType: (tab) => dispatch(setTabType(tab)),
  setStdFilterTimeTable: (std) => dispatch(setStdFilterTimeTable(std)),
  setRoomIds: (roomIds) => dispatch(setRoomIds(roomIds)),
  getJoinUsers: () => dispatch(getJoinUsers()),
  setCurrentDate: (date) => dispatch(setCurrentDate(date)),
  setTeacherfilter: (teacher) => dispatch(setTeacherfilter(teacher)),
  setClassFilter: (clasess) => dispatch(setClassFilter(clasess)),
  setSubFilter: (sub) => dispatch(setSubFilter(sub)),
  setMonthOrWeek: (isMonthOrWeek) => dispatch(setMonthOrWeek(isMonthOrWeek)),
  getRecordings: (streamId, callback) => dispatch(getRecordings(streamId, callback)),
  setCompletedSubName: (name) => dispatch(setCompletedSubName(name)),
  setPageToggle: (value) => dispatch(setPageToggle(value)),
  subscriptionAlert: () => dispatch(subscriptionAlert()),
  setJoinLoader: (bool) => dispatch(setJoinLoader(bool)),
  setCardData: (val) => dispatch(setCardData(val)),
  setQuickAccessItem: (res) => dispatch(setQuickAccessItem(res)),
  fetchSummaryData: (type, startDate, endDate, callback) =>
    dispatch(fetchSummaryData(type, startDate, endDate, callback)),
  fetchScheduleStats: (startDate, endDate, callback) =>
    dispatch(fetchScheduleStats(startDate, endDate, callback)),
  drawerBooleanState: (value) => dispatch(drawerBooleanState(value)),

});

export default connect(
  mapStateToProps,
  mapDispatchToProps

)(ScheduleAdmin);
